import styled from 'styled-components';
import ImgCalls3 from '../../Images/ImgCalls3.png';
import BgFollow from "../../Images/BgFollow.jpg";

export const Bg = styled.div`
width: 100%;
height: 700px;
/* background-color: red; */
background-image: url(${BgFollow});
background-position: bottom;
background-size:cover;
background-repeat: no-repeat;

    @media (max-width: 980px) {
        height: 600px;
        }
    @media (max-width: 670px) {
        /* height: 500px; */
    }
    @media (max-width: 760px) {
 
    }    
    @media (max-width: 550px) {

    }

`;

export const OutFollow = styled.section`
    width: 910px;
    margin: 0 auto;
    margin-bottom: -13vw;
    position: relative;
    z-index: 2;
    /* margin-top: 180px; */

    @media (max-width: 980px) {
        width: 710px;
        /* margin-top: 95px; */
    }

    @media (max-width: 760px) {
        width: 90%;
    }    
    
    @media (max-width: 550px) {
        margin-top: 55px;
        margin-bottom: -146px;
    }
`;

export const TextFollow1 = styled.div`
   margin: 0 auto;
   width: 650px;
   padding-top: 50px;

   @media (max-width: 980px) {
        width: 450px;
    }

    @media (max-width: 760px) {
        width: 350px;
    }    
    
    @media (max-width: 550px) {
        width: 200px;
    }
`;

export const OutContentFollow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 65px;

    @media (max-width: 760px) {
        flex-wrap: wrap;
        margin-top: 5px;
    }
`;

export const LeftContentFollow = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 530px;
    justify-content: space-between;

    @media (max-width: 980px) {
        width: 430px;
    }

    @media (max-width: 760px) {
        width: 100%;
    }
`;

export const ItemContentFollow = styled.div`
    width: 250px;
    height: 55px;
    background-color: #dcdcdc;
    display: flex;
    align-items: center;
    border-radius: 39px;
    cursor: pointer;

    @media (max-width: 980px) {
        width: 210px;
    }   
    
    @media (max-width: 760px) {
        width: 47%;
        margin-top: 20px;
    }    
    
    @media (max-width: 550px) {
        height: 45px;
    }
`;

export const OutItemContentFollow = styled.div`
    display: flex;
    width: 165px;
    justify-content: space-between;
    padding-left: 32px;
    padding-top: 0px;
    align-items: center;

    @media (max-width: 980px) {
        width: 145px;
    }   
    
    @media (max-width: 760px) {
        width: auto;
        margin: 0 auto;
        padding-left: 0px;
    }
`;

export const OutImgIconFollow = styled.div`
    padding-top: 7px;
`;

export const TextFollow2 = styled.div`
    font-size: 18px;
    font-weight: 800;
    color: #446fe7;

    @media (max-width: 760px) {
        padding-left: 15px;
    }    
    
    @media (max-width: 550px) {
        padding-left: 7px;
        font-size: 15px;
    }
`;

export const RiskFollow = styled.div`
    background-color: #132451;
    width: 2px;
    height: 250px;
    margin-top: -40px;

    @media (max-width: 760px) {
        display: none;
    }
`;

export const RightFollow = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 165px;

    @media (max-width: 760px) {
        width: 100%;
        flex-direction: row;
    }
`;

export const OutImgIconFollow2 = styled.div`
    cursor: pointer;

    @media (max-width: 760px) {
        width: 47%;
        margin-top: 20px;
    }
`;

export const OutImgFollow = styled.div`

`;

export const Container = styled.div`
    width: 80%;
    margin: 0 auto;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: row;
    margin-top: 60px;
    @media (max-width: 980px) {
        margin-top: 50px;
    }

    @media (max-width: 760px) {
        margin-top: 40px;
    }    
    
    @media (max-width: 550px) {
        margin-top: 30px;
    }
`;



export const ContainerLeft = styled.div`
    width: 251px;
    height: 57px;
    margin-right: 10px;
`;


export const ContainerRight = styled.div`
     width: 251px;
     height: 57px;
     margin-left: 10px;
`;



export const ContainerCenter = styled.div`
     width: 61px;
     height: 59px;
     margin-left: 10px;
     margin-right: 10px;
`;


